// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/dashboard/v1/private/dashboard.proto" (package "c1.api.dashboard.v1.private", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { Dashboard } from "./dashboard";
import type { GetConflictsOverviewResponse } from "./dashboard";
import type { GetConflictsOverviewRequest } from "./dashboard";
import type { GetAccessOverviewResponse } from "./dashboard";
import type { GetAccessOverviewRequest } from "./dashboard";
import type { GetTasksOverviewResponse } from "./dashboard";
import type { GetTasksOverviewRequest } from "./dashboard";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { DashboardView } from "./dashboard";
import type { GetDashboardRequest } from "./dashboard";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service c1.api.dashboard.v1.private.Dashboard
 */
export interface IDashboardClient {
    /**
     * @generated from protobuf rpc: GetDashboardState(c1.api.dashboard.v1.private.GetDashboardRequest) returns (c1.api.dashboard.v1.private.DashboardView);
     */
    getDashboardState(input: GetDashboardRequest, options?: RpcOptions): UnaryCall<GetDashboardRequest, DashboardView>;
    /**
     * @generated from protobuf rpc: GetTasksOverview(c1.api.dashboard.v1.private.GetTasksOverviewRequest) returns (c1.api.dashboard.v1.private.GetTasksOverviewResponse);
     */
    getTasksOverview(input: GetTasksOverviewRequest, options?: RpcOptions): UnaryCall<GetTasksOverviewRequest, GetTasksOverviewResponse>;
    /**
     * @generated from protobuf rpc: GetAccessOverview(c1.api.dashboard.v1.private.GetAccessOverviewRequest) returns (c1.api.dashboard.v1.private.GetAccessOverviewResponse);
     */
    getAccessOverview(input: GetAccessOverviewRequest, options?: RpcOptions): UnaryCall<GetAccessOverviewRequest, GetAccessOverviewResponse>;
    /**
     * @generated from protobuf rpc: GetConflictsOverview(c1.api.dashboard.v1.private.GetConflictsOverviewRequest) returns (c1.api.dashboard.v1.private.GetConflictsOverviewResponse);
     */
    getConflictsOverview(input: GetConflictsOverviewRequest, options?: RpcOptions): UnaryCall<GetConflictsOverviewRequest, GetConflictsOverviewResponse>;
}
/**
 * @generated from protobuf service c1.api.dashboard.v1.private.Dashboard
 */
export class DashboardClient implements IDashboardClient, ServiceInfo {
    typeName = Dashboard.typeName;
    methods = Dashboard.methods;
    options = Dashboard.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: GetDashboardState(c1.api.dashboard.v1.private.GetDashboardRequest) returns (c1.api.dashboard.v1.private.DashboardView);
     */
    getDashboardState(input: GetDashboardRequest, options?: RpcOptions): UnaryCall<GetDashboardRequest, DashboardView> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetDashboardRequest, DashboardView>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetTasksOverview(c1.api.dashboard.v1.private.GetTasksOverviewRequest) returns (c1.api.dashboard.v1.private.GetTasksOverviewResponse);
     */
    getTasksOverview(input: GetTasksOverviewRequest, options?: RpcOptions): UnaryCall<GetTasksOverviewRequest, GetTasksOverviewResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetTasksOverviewRequest, GetTasksOverviewResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetAccessOverview(c1.api.dashboard.v1.private.GetAccessOverviewRequest) returns (c1.api.dashboard.v1.private.GetAccessOverviewResponse);
     */
    getAccessOverview(input: GetAccessOverviewRequest, options?: RpcOptions): UnaryCall<GetAccessOverviewRequest, GetAccessOverviewResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetAccessOverviewRequest, GetAccessOverviewResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetConflictsOverview(c1.api.dashboard.v1.private.GetConflictsOverviewRequest) returns (c1.api.dashboard.v1.private.GetConflictsOverviewResponse);
     */
    getConflictsOverview(input: GetConflictsOverviewRequest, options?: RpcOptions): UnaryCall<GetConflictsOverviewRequest, GetConflictsOverviewResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetConflictsOverviewRequest, GetConflictsOverviewResponse>("unary", this._transport, method, opt, input);
    }
}
